import SVG from './SVG'

export const SearchSVG = ({ color, ...props }) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <g className="search">
        <path
          fill={color}
          fillRule="evenodd"
          d="M4 11a7 7 0 1112.041 4.857 1.005 1.005 0 00-.184.184A7 7 0 014 11zm12.618 7.032a9 9 0 111.414-1.414l3.675 3.675a1 1 0 11-1.414 1.414l-3.675-3.675z"
          className="Union"
          clipRule="evenodd"
        />
      </g>
    </SVG>
  )
}
